import "./App.css";
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Dashboard from "./Components/Landlord/Dashboard";
import EditProperty from "./Components/Landlord/EditProperty";
import Profile from "./Components/Landlord/Profile";
import LandlordLayout from "./Components/Landlord/layouts/LandlordLayout";
import Properties from "./Components/Screens/Properties";
import Login from './Components/Screens/Login';
import AddProperty from "./Components/Landlord/AddProperty";
import DashboardProperties from "./Components/Landlord/Properties";
import '@fortawesome/fontawesome-free/css/all.min.css';
import Enquiries from "./Components/Landlord/Enquiries";
import Settings from "./Components/Landlord/Settings";
import Signup from "./Components/Screens/Signup";
import Chat from "./Components/Screens/Chat";
import LandlordChat from "./Components/Landlord/LandlordChat";
import Logout from "./Components/Landlord/Logout";
import Swal from 'sweetalert2';
import ConversationsList from "./Components/Landlord/ConversationsList";
import Conversations from "./Components/Screens/Conversations";
import SuggestedProperties from "./Components/Screens/SuggestedProperties"
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PasswordReset from './Components/Screens/PasswordReset';
import AllUsers from './Components/Admin/Screens/AllUsers';
import AdminDashboard from './Components/Admin/Screens/AdminDashboard';
import Reviews from './Components/Admin/Screens/Reviews';
import Analytics from './Components/Admin/Screens/Analytics';
import AdminProperties from './Components/Admin/Screens/AdminProperties';
import TenantProfile from './Components/Screens/TenantProfile';
import Property from "./Components/SubComponents/Property";
import PropertyDetail from "./Components/Landlord/PropertyDetail";
import AdminPropertyDetail from "./Components/Admin/Screens/AdminPropertyDetail";

// Protected Route for Landlords
const LandlordRoute = ({ children }) => {
  const navigate = useNavigate();
  
  useEffect(() => {
    try {
      const token = localStorage.getItem('token');
      const currentUser = JSON.parse(localStorage.getItem('user'));

      if (!token || !currentUser) {
        navigate('/login');
        return;
      }

      if (!currentUser.user.is_landlord) {
        Swal.fire({
          title: 'Access Denied',
          text: 'This area is restricted to landlords only',
          icon: 'error',
          confirmButtonColor: '#1a237e'
        }).then(() => {
          navigate('/');
        });
      }
    } catch (error) {
      console.error('Auth check error:', error);
      navigate('/login');
    }
  }, [navigate]);

  return children;
};

// Protected Route for Authenticated Users
const AuthRoute = ({ children }) => {
  const currentUser = JSON.parse(localStorage.getItem('user'));
  const token = localStorage.getItem('token');

  if (!currentUser || !token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          
          {/* Protected Landlord Routes */}
          <Route path="/landlord/*" element={
            <LandlordRoute>
              <LandlordLayout />
            </LandlordRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="properties" element={<DashboardProperties />} />
            <Route path="add-property" element={<AddProperty />} />
            <Route path="edit-property/:id" element={<EditProperty />} />
            <Route path="property/:id" element={<PropertyDetail />} />
            <Route path="profile" element={<Profile />} />
            <Route path="settings" element={<Settings />} />
            
            
          </Route>

          {/* Protected Chat Routes */}
          <Route path="/landlord/conversations" element={<ConversationsList />} />
          <Route path="/landlord/chat/:chatId" element={<LandlordChat />} />
          <Route path="/conversations" element={<Conversations />} />
          <Route path="/chat/:chatId" element={<Chat />} />
          <Route path="/my-profile" element={<TenantProfile />} />

          {/* Public Routes */}
          <Route path="/" element={<SuggestedProperties />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/reset-password/:uid/:token" element={<PasswordReset />} />
          <Route path="/properties/:id" element={<Property />} />

          {/* Admin Routes */}
          
          <Route path="admin/dashboard" element={<AdminDashboard />} />
          <Route path="admin/all-users" element={<AllUsers />} />
          <Route path="admin/reviews" element={<Reviews />} />
          <Route path="admin/properties" element={<AdminProperties />} />
          <Route path="admin/analytics" element={<Analytics />} />
          <Route path="admin/property/:id" element={<AdminPropertyDetail />} />
         
        </Routes>
      </Router>
    </div>
  );
}

export default App;
